<template>
    <div class="container-fluid">
        <div class="form-border">
            <div class="col-12 form-wrapper col-md-12 col-lg-8 col-sm-12">
                <div class="row ">


                    <!--input-->
                    <div class="col-12 col-lg-12 col-sm-12">
                        <div class="form-group">
                            <input id="login" v-model="name" class="form-input" placeholder=" ">
                            <label for="login" class="form-label">Locatie naam <span class="required">*</span></label>
                            <span v-if="error_list.name" class="error-label">{{ error_list.name[0] }}</span>
                        </div>
                    </div>
                    <!--input-->

                    <!--input-->
                    <div class="col-6 col-lg-6 col-sm-6">
                        <div class="form-group">
                            <input id="longitude" v-model="longitude" class="form-input" placeholder=" ">
                            <label for="login" class="form-label">Longitude <span class="required">*</span></label>
                            <span v-if="error_list.longitude" class="error-label">{{ error_list.longitude[0] }}</span>
                        </div>
                    </div>
                    <!--input-->

                    <!--input-->
                    <div class="col-6 col-lg-6 col-sm-6">
                        <div class="form-group">
                            <input id="latitude" v-model="latitude" class="form-input" placeholder=" ">
                            <label for="login" class="form-label">Latitude <span class="required">*</span></label>
                            <span v-if="error_list.latitude" class="error-label">{{ error_list.latitude[0] }}</span>
                        </div>
                    </div>
                    <!--input-->


                    <div class="col-12 col-lg-4 col-sm-4">
                        <div class="form-group">
                            <input min="0" v-model="delivery_delay" id="delivery_delay" class="form-input" type="number" placeholder=" ">
                            <label for="delivery_delay" class="form-label">Bezorgingsvertraging</label>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 col-sm-4">
                        <div class="form-group">
                            <input min="0" v-model="pickup_delay" id="pickup_delay" class="form-input" type="number" placeholder=" ">
                            <label for="pickup_delay" class="form-label">Ophaalvertraging</label>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 col-sm-4">
                        <div class="form-group">
                            <input min="0" v-model="max_travel_time" id="max_travel_time" class="form-input" type="number" placeholder=" ">
                            <label for="max_travel_time" class="form-label">Maximale reistijd</label>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 col-sm-4">
                        <div class="form-group">
                            <input min="0" v-model="price_limit" id="price_limit" class="form-input" type="number" placeholder=" ">
                            <label for="price_limit" class="form-label">Prijslimiet(Price limit)</label>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 col-sm-4">
                        <div class="form-group">
                            <input min="0" v-model="orders_limit" id="orders_limit" class="form-input" type="number" placeholder=" ">
                            <label for="orders_limit" class="form-label">Het aantal bestellingen(Orders limit)</label>
                        </div>
                    </div>


                   <div class="col-12">
                       <div class="row">
                           <div class="col-12 col-lg-4 col-sm-4">
                               <div class="form-group">
                                   <input min="0" v-model="bicycle_distance" id="bicycle_distance" class="form-input" type="number" placeholder=" ">
                                   <label for="price_limit" class="form-label">Fiets afstand(Bicycle distance)</label>
                               </div>
                           </div>

                           <div class="col-12 col-lg-4 col-sm-4">
                               <div class="form-group">
                                   <input min="0" v-model="motorbike_distance" id="motorbike_distance" class="form-input" type="number" placeholder=" ">
                                   <label for="orders_limit" class="form-label">Motor afstand(Motorbike distance)</label>
                               </div>
                           </div>
                       </div>
                   </div>


                </div>
            </div>
        </div>

        <div class="">
            <div class="form-buttons">
                <button @click="createLocation" class="btn-form-submit btn-form-submit--blue">Save</button>
            </div>
        </div>
    </div>

</template>

<script>
import Multiselect from 'vue-multiselect'
import Switches from 'vue-switches';

export default {
    name: "Create",

    props: ['location'],

    data() {
        return {

            name: this.location ? this.location.name : '',
            longitude: this.location ? this.location.longitude : '',
            latitude: this.location ? this.location.latitude : '',

            pickup_delay: this.location ? this.location.pickup_delay : 0,
            delivery_delay: this.location ? this.location.delivery_delay : 0,
            max_travel_time: this.location ? this.location.max_travel_time : 0,

            price_limit: this.location ? this.location.price_limit : 0,
            orders_limit: this.location ? this.location.orders_limit : 0,

            bicycle_distance: this.location ? this.location.bicycle_distance : 0,
            motorbike_distance: this.location ? this.location.motorbike_distance : 0,

            error_list: {},

        }
    },

    methods: {
        createLocation() {
            axios.post('/api/v1/insert-order/location/save', {
                actionType: this.location ? 'update' : 'save',
                locationId: this.location ? this.location.id : false,
                name: this.name,
                longitude: this.longitude,
                latitude: this.latitude,

                pickup_delay: this.pickup_delay,
                delivery_delay: this.delivery_delay,
                max_travel_time: this.max_travel_time,
                price_limit: this.price_limit,
                orders_limit: this.orders_limit,

                bicycle_distance: this.bicycle_distance,
                motorbike_distance: this.motorbike_distance,
            })
                .then(r => {
                    this.error_list = false;

                    if(this.location) {
                        this.$toasted.show('Location has been changed!', {
                            theme: "bubble",
                            position: "bottom-center",
                            duration: 3000
                        })
                    } else {
                        setTimeout(function () {
                            window.location.href = '/insert-order/location'
                        }, 300);
                    }

                })
                .catch(e => {
                    this.error_list = e.response.data.errors
                });
        }
    }
}
</script>
